import posthog from "posthog-js";
import { isProduction } from "@/Environment";

export function resetPostHogUser(): void {
  if (!isProduction()) {
    return;
  }

  posthog.reset();
}
